<template>
    <rkm-layout-body title="Lista de setor">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-setor-create' })"
                color="primary"
                authorize="store-cadastro-setor"
            >
                Cadastrar setor
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/setor/List'

export default {
    components: { List },
}
</script>